<script>
	import ImageOptimiser from '$lib/components/common/ImageOptimiser.svelte';
	// images
	import logo from '$vl/lib/assets/icons/vl_logo.svg';
	import youtube from '$vl/lib/assets/icons/footer-icons/youtube.svelte';
	import instagram from '$vl/lib/assets/icons/footer-icons/instagram.svelte';
	import facebook from '$vl/lib/assets/icons/footer-icons/facebook.svelte';
	import X from '$vl/lib/assets/icons/footer-icons/X.svelte';
	import swiggy from '$vl/lib/assets/icons/footer-icons/swiggy.svelte';
	import zomato from '$vl/lib/assets/icons/footer-icons/zomato.svelte';
	import playStore from '$vl/lib/assets/icons/footer-icons/playStore.svg';
	import appStore from '$vl/lib/assets/icons/footer-icons/appStore.svg';
	import paytm from '$vl/lib/assets/icons/footer-icons/paytm.svg';
	import phonepe from '$vl/lib/assets/icons/footer-icons/phonepe.svg';
	import upi from '$vl/lib/assets/icons/footer-icons/upi.svg';
	import googlePay from '$vl/lib/assets/icons/footer-icons/google-pay.svg';
	import visa from '$vl/lib/assets/icons/footer-icons/visa.svg';
	import mastercard from '$vl/lib/assets/icons/footer-icons/mastercard.svg';

	let socialLinks = [
		{
			name: 'youtube',
			link: 'https://www.youtube.com/c/VibrantLivingbySrideviJasti',
			icon: youtube
		},
		{
			name: 'instagram',
			link: 'https://www.instagram.com/vibrantlivingbysridevijasti/?igshid=YmMyMTA2M2Y%3D',
			icon: instagram
		},
		{
			name: 'facebook',
			link: 'https://www.facebook.com/srivl',
			icon: facebook
		},
		{
			name: 'X',
			link: 'https://x.com/vibrant_foods',
			icon: X
		},
		{
			name: 'swiggy',
			link: 'https://www.swiggy.com/restaurants/vibrant-living-foods-prasanth-hills-manikonda-hyderabad-126873',
			icon: swiggy
		},
		{
			name: 'zomato',
			link: 'https://www.zomato.com/hyderabad/vibrant-living-foods-by-sridevi-jasti-manikonda',
			icon: zomato
		}
	];

	let paymentPartners = [
		{
			name: paytm
		},
		{
			name: phonepe
		},
		{
			name: googlePay
		},
		{
			name: upi
		},
		{
			name: mastercard
		},
		{
			name: visa
		}
	];

	let footerLinks = [
		{
			name: 'Privacy Policy',
			link: '/privacy-policy'
		},
		{
			name: 'Terms & Conditions',
			link: '/terms-and-conditions'
		},
		{
			name: 'Shipping & Delivery',
			link: 'https://vibrantliving.in/pages/shipping-delivery'
		},
		{
			name: 'Refund & Cancellation',
			link: '/returns-refunds-cancellations'
		},
		{
			name: 'About Us',
			link: 'https://vibrantliving.in/pages/about-us'
		},
		{
			name: 'Recipes & Blogs',
			link: 'https://recipes.vibrantliving.in/'
		},
		{
			name: 'Contact Us',
			link: 'https://vibrantliving.in/pages/contact'
		}
	];
</script>

<div
	class="relative bg-white p-8 lg:pb-10 lg:pt-8"
	style="box-shadow: 0px -4px 16px 0px rgba(0, 0, 0, 0.1); overflow:visible;"
>
	<div
		class="flex flex-col items-center justify-center md:mt-[72px] lg:mx-auto lg:max-h-[512px] lg:max-w-[866px]"
	>
		<div class="flex flex-col items-center gap-3">
			<div class="h-[46px] w-[80px] lg:h-[60px] lg:w-[104px]">
				<ImageOptimiser src={logo} alt="logo" classes={{ image: 'w-full h-full object-cover' }} />
			</div>
			<p
				class="mt-3 text-center font-roboto text-16 font-bold leading-6 text-[#362818] md:text-20 md:font-medium md:leading-8"
			>
				“Simplify Your Journey to Healthy Meals”
			</p>
		</div>
		<div class="mt-8 flex w-full flex-col items-center gap-3 md:mt-9">
			<p class="text-center font-roboto text-16 font-medium leading-6 text-[#362818]">We are on</p>
			<div class="mx-auto flex w-full max-w-[500px] items-center justify-between">
				{#each socialLinks as link}
					<a href={link.link} target="_blank">
						<link.icon></link.icon>
						<!-- <ImageOptimiser
							src={link.icon}
							alt={link.name}
							classes={{
								container: 'w-8 h-8 lg:w-10 lg:h-10',
								image: 'w-full h-full object-cover'
							}}
						/> -->
					</a>
				{/each}
			</div>
		</div>
		<div class="mt-[42px] flex w-full items-center justify-center gap-8">
			<a
				href="https://play.google.com/store/apps/details?id=com.apexcommerce.vibrantliving.daily"
				target="_blank"
			>
				<ImageOptimiser
					src={playStore}
					alt="playStore"
					classes={{
						container: 'w-[124px] h-9 lg:w-[152px] lg:h-11',
						image: 'w-full h-full object-cover'
					}}
				/>
			</a>
			<a href="https://apps.apple.com/in/app/vibrant-living-daily/id6737483632" target="_blank">
				<ImageOptimiser
					src={appStore}
					alt="appStore"
					classes={{
						container: 'w-[124px] h-9 lg:w-[152px] lg:h-11',
						image: 'w-full h-full object-cover'
					}}
				/>
			</a>
		</div>
		<div class="mt-[42px] flex items-center justify-center gap-3 md:max-h-[35px] md:w-[340px]">
			{#each paymentPartners as partner}
				<div>
					<img src={partner.name} alt={partner.name} class="h-full w-full object-cover" />
				</div>
			{/each}
		</div>
		<div class="mt-[42px] flex flex-wrap items-center justify-center gap-6">
			{#each footerLinks as link}
				<a
					class="text-center font-roboto text-16 font-normal leading-6 text-[#362818]"
					href={link.link}>{link.name}</a
				>
			{/each}
		</div>
		<div class="flex flex-col md:flex-row gap-4 justify-between items-center px-8 font-base pb-5">
			<p class="mt-8 text-center font-roboto text-16 font-normal leading-6 text-[#362818]">
				&copy; {new Date().getFullYear()} Vibrant Living. All rights reserved
			</p>
			<a target="_blank" href="https://www.apexcommerce.com?utm_source=swapnow&utm_medium=swapnow_website&utm_campaign=powered_by_apex" class="text-iris_primary text-base font-normal md:mt-8">
				Powered by<strong>www.apexcommerce.com</strong>
			</a>
		</div>
	</div>
</div>
